import { ApiUrls } from "appConstants/apis";
import { TenantType } from "models/tenant/TenantType";
import { BaseServices } from "./baseServices";

export class TenantTypeService extends BaseServices<TenantType> {
	constructor() {
		super(TenantType);
	}

	async getList() {
		return this.list(ApiUrls.tenantType.getList).then(
			(resources: any[]) => resources
		);
	}
}
